import React, { useEffect, useRef, useState } from "react";
//i18n
import { withNamespaces } from "react-i18next";
import exportFromJSON from "export-from-json";

import {
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  CardSubtitle,
  Container,
  Button,
  Spinner,
} from "reactstrap";


import {
  AvForm,
  AvField,
} from "availity-reactstrap-validation";

// Redux
import { connect } from "react-redux";
import { Link, withRouter } from "react-router-dom";

//Import Breadcrumb
import Breadcrumb_2Items from "../../../../components/Common/Breadcrumb_2Items";

import BootstrapTable from "react-bootstrap-table-next";
import "../../../../../node_modules/react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider, {
  Search,
} from "react-bootstrap-table2-toolkit";

import { postSubmitForm } from "../../../../helpers/forms_helper";
import showNotification from "../../../../helpers/show_notification";
import { convertToLowestUnit, ExportAvailableInCSVForReports, formatUnitsForReport,  } from "../../../../helpers/units";
import printDiv from "../../../../helpers/print_data";

const ViewInventoryAllBranches = (props) => {
  const { SearchBar } = Search;
  useEffect(() => {
    loadAllBranches();
  }, []);
  const [allBranches, setAllBranches] = useState([]);
  const [selectedBranch, setSelectedBranch] = useState("");
  const [pageCount, setPageCount] = useState(1);
  const [pageNumber, setPageNumber] = useState(1);
  const [tablePage, setTablePage] = useState(1);
  const [pageSize, setPageSize] = useState(50);
  const [isLoadingProducts, setIsLoadingProducts] = useState(false);
  const productsRequestId = useRef(0);
  const loadAllBranches = async () => {
    let url = process.env.REACT_APP_BASEURL + "stores/getall";
    let response = await postSubmitForm(url, "");
    if (response.status === 1) {
      const res = response.data.filter(
        (store) => store.type === "Branch" || store.type === "CENTRAL KITCHEN STORE"
      );
      setAllBranches(res);
    } else {
      showNotification(response.message, "Error");
    }
  };
  useEffect(() => {
    loadProducts();
  }, [selectedBranch, pageNumber]);

  const [allProducts, setAllProducts] = useState([]);
  const loadProducts = async () => {
    if (!selectedBranch) {
      setAllProducts([]);
      setPageCount(1);
      return;
    }
    const requestId = ++productsRequestId.current;
    try {
      setIsLoadingProducts(true);
      setAllProducts([]);
      setTablePage(1);
      let url = process.env.REACT_APP_BASEURL + "branchproducts/get_by_branch";
      const response = await postSubmitForm(url, {
        branch_id: selectedBranch,
        page_number: pageNumber,
      });
      if (requestId !== productsRequestId.current) return;
      if (response && response.status === 1) {
        setPageCount(Math.ceil((response.data[0]?.totalCount || 0) / 1000) || 1);
        setAllProducts(
          (response.data || []).map((row) => ({
            ...row,
            row_key: row.row_key || `${row.product_id}_${row.branch_id || ""}`,
          }))
        );
      } else {
        setAllProducts([]);
        setPageCount(1);
        if (response && response.message && response.message !== "No data found.") {
          showNotification(response.message, "Error");
        }
      }
    } catch (error) {
      if (requestId !== productsRequestId.current) return;
      setAllProducts([]);
      showNotification(error, "Error");
    } finally {
      if (requestId === productsRequestId.current) {
        setIsLoadingProducts(false);
      }
    }
  };


  const columns = [
    {
      dataField: "_id",
      hidden: true,
      csvExport: false,
    },
    {
      dataField: "_id",
      formatter: (cell, row, rowIndex) => {
        return (pageNumber - 1) * 1000 + (tablePage - 1) * pageSize + rowIndex + 1;
      },
      text: props.t("#"),
      headerStyle: (colum, colIndex) => {
        return { width: "5%" };
      },
      csvExport: false,
    },
    {
      text: props.t("Branch"),
      dataField: "branch_name",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "12%" };
      },
    },
    {
      text: props.t("Name"),
      dataField: "name",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "12%" };
      },
    },
    {
      dataField: "section",
      text: props.t("Section"),
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "8%" };
      },
    },
    {
      dataField: "category",
      text: props.t("Category"),
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "8%" };
      },
    },
    {
      dataField: "threshold",
      text: props.t("Threshold"),
      formatter: (cell, row) => {
        return (
          row.threshold + " " + row.unit_for_threshold 
        )
      },
      sort: false,
      headerStyle: (colum, colIndex) => {
        return { width: "8%" };
      },
    },
    {
      dataField: "available",
      text: props.t("Available"),
      sort: true,
      formatter:(cell,row)=>{
        let threshold = convertToLowestUnit(row?.unit_levels,[{unit:row?.unit_for_threshold,value:row?.threshold}]);
        let totalAvailable =   convertToLowestUnit(row?.unit_levels,row?.available)
 
      if (totalAvailable<=threshold) {
        return (
          <span className="font-size-12 badge-soft-danger badge badge-danger badge-pill mr-1 mb-1">
            {formatUnitsForReport(row.available,row.unit_levels)}
          </span>
        );
      } else {
        return formatUnitsForReport(row.available,row.unit_levels);
      }
      },
      headerStyle: (colum, colIndex) => {
        return { width: "10%" };
      },
    },
   
  ];
  const customTotal = (from, to, size) => (
    <span className="react-bootstrap-table-pagination-total">
      {" "}
      Showing {from} - {to} of {size} records.
    </span>
  );

  const pagination_options = {
    page: tablePage,
    sizePerPage: pageSize,
    onPageChange: (page, sizePerPage) => {
      setTablePage(page);
      setPageSize(sizePerPage);
    },
    paginationSize: 5,
    pageStartIndex: 1,
    firstPageText: "First",
    prePageText: "Prev",
    nextPageText: "Next",
    lastPageText: "Last",
    nextPageTitle: "First",
    prePageTitle: "Pre page",
    firstPageTitle: "Next page",
    lastPageTitle: "Last page",
    showTotal: true,
    paginationTotalRenderer: customTotal,
    disablePageTitle: true,
    sizePerPageList: [
      { text: "50", value: 50 },
      { text: "100", value: 100 },
      { text: "200", value: 200 },
    ],
    hideSizePerPage: false,
    ignoreSinglePage: true,
  };

  const handleDownload = async () => {
    const fileName = "finished_product_branch_inventory";
    const exportType = "xls";

    let data_to_export = allProducts;

    if (data_to_export) {
      var data = [];
      data_to_export.forEach(function (v) {
        data.push({
          Branch: v.branch_name,
          Name: v.name,
          Section: v.section,
          Category: v.category,
          available:v.available && v.available.length > 0 ? ExportAvailableInCSVForReports(v.available) : " ",
          Threshold: v.threshold + " " + v.unit_for_threshold,
        });
      });

      exportFromJSON({ data, fileName, exportType });
    }
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumb_2Items
            alternateTitle={props.t("Finished Product Branch Inventory")}
            title={props.t("Branch Inv. Transfer")}
            breadcrumbItem1={props.t("Fininshed Products")}
            breadcrumbItem2={props.t("Finished Product Branch Inventory ")}
          />
          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  <AvForm>
                    <CardTitle>{props.t("Branch Inventory")}</CardTitle>
                    <CardSubtitle className="mb-3">
                      {props.t("Select a branch to view its inventory")}
                    </CardSubtitle>
                    <Row>
                      <Col lg={6}>
                        <AvField
                          name="branch"
                          // label={props.t("Select Branch")}
                          type="select"
                          value={selectedBranch}
                          errorMessage={props.t("Branch cannot be empty")}
                          onChange={(e) => {
                            setPageNumber(1);
                            setTablePage(1);
                            setSelectedBranch(e.target.value);
                          }}
                        >
                          <option value="">{props.t("Select a branch")}</option>
                          <option value="All">{props.t("All")}</option>
                          {allBranches &&
                            allBranches.map((e) => (
                              <option key={e._id} value={e._id} name={e.name}>
                                {e.name}
                              </option>
                            ))}
                        </AvField>
                      </Col>
                    </Row>
                    {/* <Button type="submit">Submit</Button> */}
                  </AvForm>
                </CardBody>
              </Card>
            </Col>
          </Row>

          <Row>
            <Col className="col-12">
              <Card>
                <CardBody>
                  <Row className="mb-2">
                    <Col sm="4">
                      <Button
                        type="submit"
                        className="btn btn-sm btn-secondary"
                        onClick={handleDownload}
                      >
                        <i className="mdi mdi-file-export"></i>{" "}
                        {props.t("Export CSV")}
                      </Button>
                      {"   "}
                      <Link
                        to="#"
                        onClick={() => {
                          printDiv("printDiv");
                        }}
                        className="btn btn-sm btn-success mr-2"
                      >
                        <i className="fa fa-print"></i> Print
                      </Link>
                      <div className="search-box mr-2 mb-2 d-inline-block">
                        <div className="position-relative"></div>
                      </div>
                    </Col>
                  </Row>
                  <div id="printDiv">
                    <CardTitle className="text-center">
                      {props.t("Finished Product Branch Inventory")}
                    </CardTitle>
                    <ToolkitProvider
                      bootstrap4
                      keyField="row_key"
                      data={allProducts || []}
                      columns={columns}
                      search
                      exportCSV
                    >
                      {(toolkitProps) => (
                        <div>
                          <Row>
                            <Col lg={4}>
                              <SearchBar
                                {...toolkitProps.searchProps}
                                style={{ width: "300px" }}
                              />
                            </Col>
                            <Col lg={4}></Col>{" "}
                            <Col lg={4} className="text-right"></Col>
                          </Row>
                          <BootstrapTable
                            striped
                            hover
                            condensed
                            pagination={paginationFactory(pagination_options)}
                            noDataIndication={
                              isLoadingProducts ? (
                                <Spinner size="md" />
                              ) : selectedBranch ? (
                                props.t("No data to display.")
                              ) : (
                                props.t("Select a branch to view its inventory")
                              )
                            }
                            {...toolkitProps.baseProps}
                          />
                        </div>
                      )}
                    </ToolkitProvider>
                  </div>
                  {pageCount > 1 && (
                  <div>
                    <br />
                    {[...Array(pageCount)].map((x, i) => (
                      <button
                        key={i}
                        onClick={() => {
                          setTablePage(1);
                          setPageNumber(i + 1);
                        }}
                        className={
                          pageNumber === i + 1 ? "btn btn-primary" : "btn"
                        }
                      >
                        {i + 1}
                      </button>
                    ))}
                  </div>
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};
const mapStatetoProps = (state) => {};
export default withRouter(
  connect(mapStatetoProps, {})(withNamespaces()(ViewInventoryAllBranches))
);
